import { render } from "./matching-card-options.vue?vue&type=template&id=78d5583a&scoped=true&ts=true"
import script from "./matching-card-options.vue?vue&type=script&lang=ts"
export * from "./matching-card-options.vue?vue&type=script&lang=ts"

import "./matching-card-options.vue?vue&type=style&index=0&id=78d5583a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d5583a"]])

export default __exports__